module.exports = __webpack_public_path__ + "images/emoji/football.912cc9abf874571d0725.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/football.png
// module id = /GqE
// module chunks = 1